import clsx from 'clsx'

type Props = {
  heading: string
  subheading?: string | string[]
  textAlign?: 'left' | 'center' | 'right'
}

export default function Header ({
  heading,
  subheading,
  textAlign = 'center',
}: Props) {
  const subheadings = subheading ? (Array.isArray(subheading) ? subheading : [subheading]) : undefined

  return (
    <div className={clsx('flex flex-col gap-4', {
      'text-left': textAlign === 'left',
      'text-center': textAlign === 'center',
      'text-right': textAlign === 'right',
    })}
    >
      <h1 className='heading-md'>{heading}</h1>
      {subheadings && (
        <div className='flex flex-col gap-2'>
          {subheadings.map((line, index) => (
            <p key={index} className='body text-gray-500'>{line}</p>
          ))}
        </div>
      )}
    </div>
  )
}
